<template>
  <div class="container">
    <div class="bsd-section">
      <div class="row">
        <div class="col-md-12">
          <div class="z-title z-title--small spacer-bottom-s">
            Olá, {{ student.first_name }}.
          </div>
          <p class="z-text">
            Gerencie a mensalidade de
            <strong>{{ currentBilling.course_name }}</strong> -
            <strong>{{ currentBilling.institution_name }}</strong>.
          </p>
        </div>
      </div>
    </div>

    <div class="bsd-section">
      <course-selector />
    </div>

    <alerts />

    <div class="bsd-section">
      <div class="main-cards-wrapper">
        <bill-card />

        <action-card
          title="Próximas mensalidades"
          :route="{ name: 'next-bills' }"
          icon="file-invoice-dollar"
          class="next-bills-card"
        />
        <action-card
          title="Histórico de pagamento"
          :route="{ name: 'payments-history' }"
          icon="list-alt"
          class="payments-history-card"
        />
        <action-card
          title="Trocar forma de pagamento"
          :route="{ name: 'change-payment-method' }"
          class="change-payment-method-card"
          icon="exchange"
          v-if="canChangePaymentMethod"
        />
        <action-card
          title="Dúvidas? Fale com a gente"
          :route="{ name: 'contacts' }"
          icon="comments-alt"
          :class="{'contacts-card': canChangePaymentMethod, 'change-payment-method-card': !canChangePaymentMethod }"
        />
      </div>

      <div class="z-title z-title--micro spacer-bottom-m hidden-xs hidden-sm">
        Outras opções
      </div>

      <div class="second-cards-wrapper">
        <action-card
          :title="`Pagar todo o ${currentContract.period_name}`"
          :route="{ name: 'contract-payment' }"
          icon="credit-card"
          v-if="showContractDischarge"
        />

        <action-card
          title="Trocar data de vencimento"
          :route="{ name: 'payment-configuration-due-day', query: { origin: 'home' } }"
          icon="calendar-edit"
          v-if="canChangeDueDayByInstitution && hasAvailableDays"
        />

        <action-card
          title="Meus dados"
          :route="{ name: 'profile' }"
          icon="user-astronaut"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>

.main-cards-wrapper {
  display: grid;
  grid-column-gap: var(--space-medium);
  grid-row-gap: var(--space-medium);
  grid-template-areas: 'current-bill current-bill' 'next-bills payments-history' 'full-payment contacts';
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto 144px 144px;
  margin-bottom: var(--space-medium);

  @media (min-width: $screen-md-min) {
    grid-column-gap: var(--space-extra-large);
    grid-row-gap: var(--space-large);
    grid-template-areas: 'current-bill next-bills payments-history' 'current-bill full-payment contacts';
    grid-template-columns: 2.13fr 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    margin-bottom: var(--space-jumbo);
  }
}

.second-cards-wrapper {
  display: grid;
  grid-column-gap: var(--space-medium);
  grid-row-gap: var(--space-medium);
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 144px;

  @media (min-width: $screen-md-min) {
    grid-column-gap: var(--space-extra-large);
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: auto;
  }
}

.bill-card {
  grid-area: current-bill;
}

.next-bills-card {
  grid-area: next-bills;
}

.payments-history-card {
  grid-area: payments-history;
}

.change-payment-method-card {
  grid-area: full-payment;
}

.contacts-card {
  grid-area: contacts;
}
</style>

<script>
import { mapState, mapGetters } from 'vuex';
import ActionCard from 'components/action-card';
import BillCard from 'components/bill-card';
import CourseSelector from 'components/course-selector';
import Alerts from './alerts';

export default {
  components: {
    ActionCard,
    Alerts,
    BillCard,
    CourseSelector,
  },
  computed: {
    ...mapState([
      'student',
      'currentBilling',
      'currentContract',
    ]),
    ...mapGetters([
      'permittedPaymentMethods',
      'showContractDischarge',
    ]),
    canChangePaymentMethod() {
      return this.permittedPaymentMethods.length > 1;
    },
    canChangeDueDayByInstitution() {
      return this.currentBilling.allowed_change_due_day_by_institution;
    },
    hasAvailableDays() {
      return this.currentBilling.available_due_days.length > 0;
    },
  },
  mounted() {
    this.$tracker.logEvent('Viewed Home Page');
  },
};
</script>
